import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const fmt = (n) => `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

export default function ConfirmPriceDialog({ open, onOpenChange, plan, newPrice, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-[#0A0A0A] border-[#262626]" data-testid={`plan-confirm-${plan.lookup_key}`}>
        <AlertDialogHeader>
          <AlertDialogTitle>Change the price of {plan.product_name}?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-3 text-base" data-testid={`plan-confirm-prices-${plan.lookup_key}`}>
                <span className="line-through text-muted-foreground">{fmt(plan.amount)}</span>
                <span>→</span>
                <span className="font-semibold text-[#FFD600]">{fmt(newPrice)}</span>
              </div>
              <p>New clients will pay {fmt(newPrice)} starting right away on the Pick a Plan page.</p>
              {plan.interval && <p>Clients already subscribed keep paying {fmt(plan.amount)}.</p>}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`plan-confirm-cancel-${plan.lookup_key}`}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid={`plan-confirm-ok-${plan.lookup_key}`} className="bg-[#FFD600] text-black hover:bg-[#FFD600]/90">
            Change price
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
